import { Button } from '@/components/ui/button'

interface PaginationControlsProps {
  hasPreviousPage: boolean
  hasNextPage: boolean
  onPreviousPage: () => void
  onNextPage: () => void
}

export function PaginationControls({
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage
}: PaginationControlsProps): React.ReactElement {
  return (
    <div className="flex items-center justify-end gap-2 border-t border-border/70 px-6 py-4">
      <Button
        variant="outline"
        className="rounded-none"
        disabled={!hasPreviousPage}
        onClick={onPreviousPage}
      >
        Föregående
      </Button>
      <Button
        variant="outline"
        className="rounded-none"
        disabled={!hasNextPage}
        onClick={onNextPage}
      >
        Nästa
      </Button>
    </div>
  )
}
